let UTILS = require("../libs/utils.js");
var v7726;
var v7727;
module.exports = {
  id: "oinc",
  name: "One in the Chamber",
  alias: "oinc",
  party: true,
  tag: ["Party", "#ffac00", "#ffb600"],
  endStats: ["sid", "name", "kills", "deaths", "melees"],
  leaderStats: ["lives", "kills"],
  leaderSort: function (p9168, p9169) {
    if (p9168.lives === p9169.lives && p9168.kills && p9169.kills) {
      return p9168.kills - p9169.kills;
    } else {
      return p9169.lives - p9168.lives;
    }
  },
  endSort: function (p9170, p9171) {
    if (p9170.lives === p9171.lives && p9170.kills && p9171.kills) {
      return p9171.kills - p9170.kills;
    } else {
      return p9171.lives - p9170.lives;
    }
  },
  condition: [function (game) {
    var vLN01217 = 0;
    for (var vLN01218 = 0; vLN01218 < game.players.list.length; ++vLN01218) {
      if (game.players.list[vLN01218].lives > 0) {
        vLN01217++;
      }
    }
    return vLN01217 > 1;
  }],
  winCondition: function (game) {
    for (var vLN01219 = 0; vLN01219 < game.players.list.length; ++vLN01219) {
      if (game.players.list[vLN01219].lives > 0) {
        return game.players.list[vLN01219];
      }
    }
    return null;
  },
  waitTimers: [{
    time: 10000,
    msg: "starts in ",
    trigger: function (p9174) {
      p9174.unlockMove();
    }
  }, {
    time: 100,
    msg: "",
    noJoin: true,
    trigger: function () {}
  }],
  gameStart: function (p9175) {
    p9175.lockMove();
  },
  onKill: function (game, p9177, p9178, p9179) {
    if (p9179 && p9179 != p9178) {
      p9179.ammos[0]++;
      if (p9179.ammos[0] > 7) {
        p9179.ammos[0] = 7;
      }
      p9179.send("uamo", p9179.ammos, p9179.reserveAmmos);
    }
    if (p9177) {
      game.players.syncLeaders();
    }
  },
  forceSpawn: 3,
  lives: 3,
  maxHealth: 10,
  forceClass: 10,
  ammoLimit: 1,
  noReloads: true,
  hideNames: true,
  noAssists: true,
  noStreaks: true,
  minPlayers: 2,
  noPickups: true
};